// extracted by mini-css-extract-plugin
export default {"paragraphWrapper":"ParagraphField_paragraphWrapper__+0szq","paragraph":"ParagraphField_paragraph__3lUpn"};